import React from "react";
import PageSpinner from "../../../../components/PageSpinner/PageSpinner";
import { Empty } from "antd";

interface tableProps {
  tableData: [];
  loading: boolean;
  reportType: string;
}

const Table: React.FC<tableProps> = (props) => {
  const { tableData, loading,reportType } = props;

  const monthlyData = (data: any) => {
    return (
      <>
        <thead>
          <tr>
            <th>Provider</th>
            <th>To Provider</th>
            <th>In Count</th>
            <th>Out Count</th>
            <th>Day</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item: any, index: number) => {
              return (
                <tr key={index}>
                  <td>{item.provider}</td>
                  <td>{reportType}</td>
                  <td>{item.in_count}</td>
                  <td>{item.out_count}</td>
                  <td>{item.day}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5}>
                <div className="pt-20 pb-20">
                  <Empty />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <table className="reportTable" width={"100%"}>
      {loading ? <PageSpinner /> : monthlyData(tableData)}
    </table>
  );
};

export default Table;
